// Hook do pobierania rodzajów polityk

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPolicyKind {
  value: string;
  text: string;
}

interface IResponse {
  items: IPolicyKind[];
}

const getPolicyKinds = (): Promise<IResponse> =>
  axios.get('/dev-studio/process/policy-kinds');

export const useGetPolicyKinds = (
  options?: UseQueryOptions<IResponse, IError>
) => useQuery<IResponse, IError>(['policyKinds'], () => getPolicyKinds(), options);
